import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const FilterCheckbox = ({ value, filterCode, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className='bra-input__wrapper bra-input--checkbox'>
      <input
        id={`toolbarPlpCheckbox-${value.code}`}
        className='bra-input__input'
        type='checkbox'
        checked={value.selected}
        onChange={() => onChange(value.query)}
      />
      <label
        className='bra-input__label'
        htmlFor={`toolbarPlpCheckbox-${value.code}`}
      >
        {filterCode === 'percentageDiscountValue'
          ? t('listing:filter.option.discount.range', {
              range: value.name,
            })
          : value.name}{' '}
        ({value.count})
      </label>
    </div>
  );
};

FilterCheckbox.propTypes = {
  value: PropTypes.shape(),
  filterCode: PropTypes.string,
  onChange: PropTypes.func,
};

FilterCheckbox.defaultProps = {
  value: {},
  filterCode: null,
  onChange: null,
};

export default FilterCheckbox;
